export const getUploads = (state) => state.uploads;
export const getResumableUploads = (state) => state.uploads;

export const getAuthState = (state) => state.authState;
export const getLoginState = (state) => state.authState.isLoggedIn;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/selectors/auth.js